import { createServerFn } from "@tanstack/react-start";
import * as db from "@/lib/db.server";

const COLS =
  "id, name, specialty, city, state, zip, rating, google_rating, google_review_count, photos, profile_photo_url, display_photo_url, has_custom_photo, avatar_gender, gender, listing_status, plan, is_featured, featured_subscription_status, availability, available_days, insurance, public_id";

const TTL_MS = 24 * 60 * 60 * 1000; // 24 hours
let cache: { ts: number; rows: any[] } | null = null;
let inflight: Promise<any[]> | null = null;

async function fetchRows(): Promise<any[]> {
  // Try featured providers first. Public read (no auth) — same data the
  // homepage carousel showed before; no per-user scoping needed.
  const featured = await db.query<any>(
    `SELECT ${COLS}
       FROM public.providers
      WHERE is_featured = true
        AND featured_subscription_status = 'active'
        AND is_active = true
        AND is_deleted = false
      ORDER BY rating DESC
      LIMIT 24`,
  );
  if (featured.length >= 8) return featured;

  // Fallback: top-rated active providers so the carousel is never empty
  const fallback = await db.query<any>(
    `SELECT ${COLS}
       FROM public.providers
      WHERE is_active = true
        AND is_deleted = false
        AND google_review_count IS NOT NULL
        AND google_review_count >= 20
      ORDER BY google_rating DESC NULLS LAST, google_review_count DESC
      LIMIT 24`,
  );
  return fallback;
}


export const getTopDoctors = createServerFn({ method: "GET" }).handler(async () => {
  const now = Date.now();
  if (cache && now - cache.ts < TTL_MS) return { rows: cache.rows };

  if (!inflight) {
    inflight = fetchRows()
      .then((rows) => {
        cache = { ts: Date.now(), rows };
        return rows;
      })
      .finally(() => {
        inflight = null;
      });
  }
  try {
    const rows = await inflight;
    return { rows };
  } catch (e) {
    // Serve stale on error to keep the carousel populated.
    if (cache) return { rows: cache.rows };
    return { rows: [] };
  }
});
